import { ObjectValues } from 'src/common/tsHelpers';

export const CLAIM_TYPE = {
  AuthTime: 'auth_time',
  Jti: 'jti',
  NameIdentifier: 'http://schemas.xmlsoap.org/ws/2005/05/identity/claims/nameidentifier',
  Id: 'typ',
  SessionState: 'session_state',
  AuthnClassReference: 'http://schemas.microsoft.com/claims/authnclassreference',
  Sid: 'sid',
  Role: 'cmp_roles',
  PreferredUsername: 'preferred_username',
  GivenName: 'http://schemas.xmlsoap.org/ws/2005/05/identity/claims/givenname',
  Surname: 'http://schemas.xmlsoap.org/ws/2005/05/identity/claims/surname',
  EmailAddress: 'http://schemas.xmlsoap.org/ws/2005/05/identity/claims/emailaddress',
  AccountReferenceId: 'AccountReferenceId',
  AccountType: 'AccountType',
} as const;

export type ClaimType = ObjectValues<typeof CLAIM_TYPE>;

export const USER_ROLE = {
  CSL_ADMIN: 'CSL Admin',
  CSL_TECH: 'CSL Tech',
  CSL_USER: 'CSL User',
  CUSTOMER_ADMIN: 'Customer Admin',
  CUSTOMER_TECH: 'Customer Tech',
  CUSTOMER_USER: 'Customer User',
} as const;

export const USER_ROLES: UserRole[] = Object.values(USER_ROLE);

export type UserRole = ObjectValues<typeof USER_ROLE>;

export const ACCOUNT_TYPE = {
  DIRECT: 'Direct',
  INSTALLER: 'Installer',
};

export type AccountType = ObjectValues<typeof ACCOUNT_TYPE>;

export type UserDTO = {
  claims: Claim[];
};
export type Claim =
  | {
      type: Exclude<ClaimType, 'cmp_roles' | 'AccountType'>;
      value: string;
    }
  | {
      type: 'cmp_roles';
      value: UserRole;
    }
  | {
      type: 'AccountType';
      value: AccountType;
    };

export type User = {
  givenName: string;
  surname: string;
  emailAddress: string;
  username: string;
  role: UserRole;
  referenceId: string;
  accountType?: string;
};
